<template>
  <div class="relative" :data-actions-dropdown="dropdownId">
    <button
      class="p-1.5 rounded-lg transition-colors"
      :class="
        variant === 'bordered'
          ? 'border border-gray-200 text-gray-500 hover:bg-gray-50'
          : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
      "
      @click="$emit('toggle', $event)"
    >
      <i class="pi pi-ellipsis-v text-sm"></i>
    </button>

    <div
      v-if="open"
      class="absolute right-0 top-full mt-1 w-52 bg-white border border-gray-200 rounded-lg shadow-lg py-1 text-left z-[100]"
    >
      <div class="px-3 py-1.5 text-xs font-semibold text-gray-400 uppercase">
        Действия
      </div>
      <template v-for="action in actions" :key="action.label">
        <hr v-if="action.divider" class="my-1 border-gray-100" />
        <button
          class="flex items-center gap-2 w-full px-3 py-2 text-sm hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
          :class="action.danger ? 'text-red-600' : 'text-gray-700'"
          :disabled="action.disabled"
          @click="!action.disabled && $emit('select', action, $event)"
        >
          <i
            :class="[
              'text-sm',
              action.danger ? 'text-red-400' : 'text-gray-400',
              action.icon
            ]"
          ></i>
          {{ action.label }}
        </button>
      </template>
    </div>
  </div>
</template>

<script setup>
  defineProps({
    actions: { type: Array, default: () => [] },
    open: { type: Boolean, default: false },
    variant: { type: String, default: 'plain' },
    dropdownId: { type: [String, Number], default: '' }
  })

  defineEmits(['toggle', 'select'])
</script>
